import { render } from "./ChatApp.vue?vue&type=template&id=46449386&scoped=true"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"

import "./ChatApp.vue?vue&type=style&index=0&id=46449386&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46449386"]])

export default __exports__